import app from './app';

// spanish
export default {
  app,
};
